class _SnackbarService {
    constructor() {
        /**
         * The snackbar container that is set up in `initializeSnackbarService`
         */
        this.snackbarContainer = undefined;
        /**
         * Determines whether the next snackbar should be sent to the queue
         */
        this.delayNextSnackbar = false;
        /**
         * Contains all snackbars that are currently queued for being shown, with a 1s delay between each
         */
        this.queue = [];
        /**
         * Delay for snackbars without an action
         */
        this.regularSnackbarTimeoutInMs = 6000;
        /**
         * Delay for snackbars that have an action
         */
        this.actionSnackbarTimeoutInMs = 10000;
        /**
         * Delay between multiple snackbars being activated within short succession
         */
        this.delayBetweenSnackbarsInMs = 1000;
    }
    /**
     * Shows a snackbar to the user with the provided options.
     *
     * If there is a snackbar active that was shown in the past second, the new snackbar will be sent to the queue
     * and shown after a short delay.
     * @param options The options for the snackbar to be shown
     */
    showSnackbar(options) {
        if (!this.snackbarContainer) {
            this.initializeSnackbarService();
        }
        if (this.delayNextSnackbar) {
            this.queue.push(options);
        }
        else {
            this.activateSnackbar(options);
        }
    }
    initializeSnackbarService() {
        const snackbarContainer = document.createElement('tbk-snackbar-container');
        document.body.appendChild(snackbarContainer);
        this.snackbarContainer = snackbarContainer;
    }
    createNewSnackbar(options) {
        if (!this.snackbarContainer) {
            console.warn('Something went wrong when initializing Snackbar Container, cannot find it.');
            return;
        }
        const snackbar = document.createElement('tbk-snackbar');
        this.addAttributesToSnackbar(snackbar, options);
        this.snackbarContainer.shadowRoot.appendChild(snackbar);
        return snackbar;
    }
    activateSnackbar(options) {
        // Activate delay so new snackbars go to the queue
        this.handleSnackbarDelay();
        const snackbar = this.createNewSnackbar(options);
        this.handleSnackbarRemoval(snackbar, options);
        this.checkForNextSnackbarInQueue();
    }
    checkForNextSnackbarInQueue() {
        // After the delay between snackbars, check if there is a snackbar in the queue we can show
        setTimeout(() => {
            const firstQueueElement = this.queue.shift();
            if (!firstQueueElement) {
                return;
            }
            this.activateSnackbar(firstQueueElement);
        }, this.delayBetweenSnackbarsInMs);
    }
    handleSnackbarDelay() {
        // Zeroheight specifies a minimum delay between multiple snackbars appearing
        this.delayNextSnackbar = true;
        setTimeout(() => (this.delayNextSnackbar = false), this.delayBetweenSnackbarsInMs);
    }
    handleSnackbarRemoval(snackbar, options) {
        // We want snackbars that have an action to have a longer timeout, to give the user time to actually use the action
        const delay = options.actionText !== undefined && options.actionText.length > 0 ? this.actionSnackbarTimeoutInMs : this.regularSnackbarTimeoutInMs;
        setTimeout(() => this.snackbarContainer.shadowRoot.removeChild(snackbar), delay);
    }
    addAttributesToSnackbar(snackbar, options) {
        snackbar.setAttribute('text', options.text);
        if (options.actionText)
            snackbar.setAttribute('action-text', options.actionText);
        if (options.action)
            snackbar.addEventListener('actionEvent', options.action);
        if (options.status)
            snackbar.setAttribute('status', options.status);
    }
}
// Export as a singleton
const SnackbarService = new _SnackbarService();

export { SnackbarService as S };
